import { Link, useMatch } from "react-router-dom";
import {
  IconLayoutDashboard,
  IconDeviceMobile,
  IconList,
  IconSettings
} from '@tabler/icons-react';
import { cn } from "../lib/utils";
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarNav,
  SidebarNavItem,
} from "./ui/sidebar";

const navigation = [
  { name: 'Dashboard', href: '/', icon: IconLayoutDashboard },
  { name: 'App Config', href: '/app_config', icon: IconDeviceMobile },
  { name: 'Curriculum', href: '/curriculum', icon: IconList },
  { name: 'System', href: '/system', icon: IconSettings },
];

export default function SidebarComponent() {
  return (
    <Sidebar
      className={cn(
        "font-sans min-h-screen select-none transition-all duration-300 ease-in-out border-r",
        "bg-background text-foreground border-border",
        "data-[collapsible=icon]/sidebar:w-[56px] w-[200px]"
      )}
    >
      <SidebarHeader
        className={cn(
          "flex items-center justify-center h-[56px] px-3 group-data-[collapsible=icon]/sidebar:px-1 bg-background"
        )}
      >
        <Link
          to="/"
          className={cn(
            "flex items-center w-full h-full gap-2",
            "justify-center group-data-[collapsible=icon]/sidebar:justify-center"
          )}
          style={{ minHeight: 40 }}
        >
          <div className="flex items-center justify-center w-full">
            <img src="/img/logo.svg" alt="Pro English" className="w-7 h-7 object-contain" />
            <span className="text-[18px] font-bold tracking-tight ml-2 group-data-[collapsible=icon]/sidebar:hidden">
              Pro English
            </span>
          </div>
        </Link>
      </SidebarHeader>
      <SidebarContent className="group-data-[collapsible=icon]/sidebar:px-1 px-2 pt-4">
        <SidebarNav className="flex flex-col gap-0.5 mb-6">
          {navigation.map((item) => (
            <SidebarNavItem key={item.name} className="mb-0.5">
              <SideNavLink
                title={item.name}
                icon={item.icon}
                path={item.href}
              />
            </SidebarNavItem>
          ))}
        </SidebarNav>
      </SidebarContent>
    </Sidebar>
  );
}

function SideNavLink({ title, icon: Icon, path }) {
  const match = useMatch(path);

  return (
    <Link
      to={path}
      className={cn(
        "flex items-center gap-2 rounded-[10px] px-3 py-2 text-[13px] font-normal transition-colors duration-200",
        "hover:bg-accent hover:text-accent-foreground",
        "group-data-[collapsible=icon]/sidebar:justify-center group-data-[collapsible=icon]/sidebar:gap-0 group-data-[collapsible=icon]/sidebar:px-1 group-data-[collapsible=icon]/sidebar:py-2 group-data-[collapsible=icon]/sidebar:text-[11px]",
        match && "bg-accent text-accent-foreground font-medium"
      )}
      style={{ minHeight: 36 }}
    >
      <Icon className="w-5 h-5 text-foreground group-data-[collapsible=icon]/sidebar:w-6 group-data-[collapsible=icon]/sidebar:h-6" />
      <span className="group-data-[collapsible=icon]/sidebar:hidden">{title}</span>
    </Link>
  );
}